<template>
  <div>
    <!--操作栏-->
    <div class="filter_container">
      <butn v-permission="'course:import'" btntype="primary" title="导入" @click.native="importCheck"></butn>
      <butn v-permission="'course:export'" btntype="primary" title="导出" @click.native="exportPage"></butn>
      <butn v-permission="'course:insert'" btntype="primary" title="新增" @click.native="showAddModal"
        iconName="el-icon-plus"></butn>
      <butn v-permission="'selfRoom:manage'" btntype="primary" title="自习室管理" @click.native="goRoomManage"></butn>
    </div>
    <!--表格内容栏-->
    <el-table class="courseTable" :row-style="{ color: '#51627D', fontWeight: 400 }"
      :header-cell-style="{ background: '#DCE7FA', color: '#343C4A', fontWeight: 500 }" :data="tableData"
      :span-method="objectSpanMethod" border style="width: 100%">
      <template>
        <el-table-column prop="courseDate" label="日期">
        </el-table-column>
        <el-table-column prop="courseTime" label="时间">
        </el-table-column>
        <el-table-column prop="courseName" width="250px" label="内容">
          <template slot-scope="scope">
            <span class="courseName">{{ scope.row.courseName }}</span>
            <span class="teachingForm">{{ scope.row.teachingForm }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="teacherName" label="主持人" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.unitPosition }}<br />{{ scope.row.teacherName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="teachingLocation" label="地点">
          <template slot-scope="scope">
            <div class="blue_style" v-if="scope.row.roomType == 2" @click="showRoomDetail(scope.row)">
              {{ scope.row.teachingLocation }}</div>
            <span v-else>{{ scope.row.teachingLocation }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="groupNames" label="课程面向分组">
        </el-table-column>
        <el-table-column label="课件" align="center">
          <template slot-scope="scope">
            <div class="fileName" v-if="scope.row.attachment">
              <a class="preview_text" :href="JSON.parse(scope.row.attachment)[0].url">{{
                JSON.parse(scope.row.attachment)[0].name }}</a>
            </div>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-tooltip effect="dark" content="编辑" placement="top" v-permission="'course:update'">
              <i :class="'icon-edit'" @click="editCourse(scope.row)"></i>
            </el-tooltip>
            <el-tooltip effect="dark" content="删除" placement="top" v-permission="'course:delete'">
              <i :class="'icon-delete'" @click="deleteCourse(scope.row)"></i>
            </el-tooltip>
            <el-tooltip effect="dark" content="座位号管理" placement="top" v-permission="'userSeat:page'">
              <i :class="'iconfont ic_seatnumbermanagement iconfont-adapt'" @click="goSeatManage(scope.row)"></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </template>
    </el-table>
    <!-- 日程导入 -->
    <ImportModal ref="importRef" />
    <!-- 新增/编辑 -->
    <AddModal :addDialog="addDialog" :classId="classId" @closeAddDialog="closeAddDialog" v-if="addDialog.flag" />
    <!-- 自习室组详情 -->
    <RoomGroup v-if="newDialogInfo.show" :classId="classId" :dialogInfo="newDialogInfo" @close="closeRoomDialog" />
  </div>
</template>
<script>
import {
  deleteCourseClass, exportClassCourse, getCourseList, hasSeat
} from "@/api/class";
import butn from "@/components/button/index";
import { ioRead } from "@/utils/common.js";
import AddModal from "./add.vue";
import Bus from "./Bus.js";
import ImportModal from "./importModal.vue";
import RoomGroup from "@/views/offlineClass/roomManage/components/roomGroupDialog.vue";

export default {
  components: {
    ImportModal,
    butn,
    AddModal,
    RoomGroup
  },
  data() {
    return {
      Bus,
      classId: "",
      className: "",
      classStatus: null,
      tableData: [],
      dataname: {},
      addDialog: {
        flag: false,
        editId: null
      },
      roomDetail: {
        flag: false,
        id: null
      },
      newDialogInfo: { show: false },
    };
  },
  created() {
    //加载列表
    this.classId = this.$route.query.id;
    this.className = this.$route.query.className;
    this.classStatus = this.$route.query.classStatus;
    this.$nextTick(() => {
      this.getScheduleList();
    });
  },
  methods: {
    importCheck() {
      // 培训已开始，不支持导入
      if (Number(this.classStatus) > 2) {
        this.$message({
          message: "培训已开始，如需调整课表请点击新增或编辑按钮完成～",
          type: "error",
        });
        return;
      } else {
        // 校验是否有座位号
        this.hasSeat();
      }
    },
    // 日程导入
    handleImport() {
      let item = { classId: this.classId };
      // Bus.$emit("handleImport", item);
      this.$refs.importRef.showImport(item);
    },
    // 日程列表导出
    exportPage() {
      exportClassCourse({
        classId: this.classId,
      }).then((response) => ioRead(response));
    },
    // 自习室组详情
    showRoomDetail(item) {
      this.newDialogInfo = {
        show: true,
        type: 2,
        uuid: item.roomId,
      };
    },
    // 关闭自习室组详情
    closeRoomDialog() {
      this.newDialogInfo.show = false;
    },
    // 新增
    showAddModal() {
      this.addDialog.editId = null;
      this.addDialog.flag = true;
    },
    closeAddDialog() {
      this.addDialog.flag = false;
      this.addDialog.editId = null;
    },
    // 编辑
    editCourse(item) {
      this.addDialog.editId = item.uuid;
      this.addDialog.flag = true;
    },
    // 座位号管理
    goSeatManage(item) {
      this.$router.push({ path: "/offlineClass/teaching/seatManage", query: { classId: this.classId, courseId: item.uuid, className: this.className, classStatus: this.classStatus } });
    },
    // 自习室管理
    goRoomManage() {
      this.$router.push({ path: "/offlineClass/roomManage", query: { ...this.$route.query } });
    },
    //搜索列表
    getScheduleList() {
      getCourseList({ classId: this.classId }).then(({ code, data }) => {
        if (code === 0) {
          this.tableData = data || [];
        }
      });
    },
    deleteCourse(data) {
      this.$confirm(`确认删除该日程吗？删除后课程下学员座位号会同时删除～`, "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        deleteCourseClass({ uuids: [data.uuid] }).then((res) => {
          if (res && res.code == 0) {
            this.$message.success(res.msg);
            // 更新列表
            this.getScheduleList();
          }
        });
      })
        .catch(() => { });
    },
    // 获取日程安排详情
    hasSeat() {
      hasSeat(this.classId).then(({ code, data }) => {
        if (code === 0) {
          if (data) {
            this.$confirm(`当前已有课程安排学员座位号，导入课程将清空座位号信息，确定导入吗？`, "系统提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            }).then(() => {
              this.handleImport();
            }).catch(() => { });
          } else {
            this.handleImport();
          }
        }
      });
    },
    // 合并列
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      const dataProvider = this.tableData
      const cellValue = row[column.property]
      if (cellValue) {
        // 上一条数据
        const prevRow = dataProvider[rowIndex - 1]
        // 下一条数据
        let nextRow = dataProvider[rowIndex + 1]
        // 当上一条数据等于下一条数据
        if (columnIndex === 1) {
          const currentCourseDate = row.courseDate
          // 同一天才合并时间
          let preCourseDateFlag = prevRow && prevRow.courseDate == currentCourseDate 
          if (prevRow && prevRow[column.property] === cellValue && preCourseDateFlag) {
            return{ rowspan: 0, colspan: 0 }
          } else {
            let rowspan = 1
            let nextCourseDateFlag = nextRow && nextRow.courseDate == currentCourseDate
            while (nextRow && nextRow[column.property] === cellValue && nextCourseDateFlag) {
              rowspan++
              nextRow = dataProvider[rowspan + rowIndex]
            }
            if (rowspan > 1) {
              return { rowspan, colspan: 1 }
            }
          }
        } else if (columnIndex !== 2 && columnIndex !== 3 && columnIndex !== 4) {
          if (prevRow && prevRow[column.property] === cellValue ) {
            return { rowspan: 0, colspan: 0 }
          } else {
            let rowspan = 1
            while (nextRow && nextRow[column.property] === cellValue) {
              rowspan++
              nextRow = dataProvider[rowspan + rowIndex]
            }
            if (rowspan > 1) {
              return { rowspan, colspan: 1 }
            }
          }
        } else if (columnIndex == 2) {
          if (prevRow && prevRow[column.property] === cellValue && (prevRow.teachingForm === row.teachingForm)) {
            return { rowspan: 0, colspan: 0 }
          } else {
            let rowspan = 1
            while (nextRow && nextRow[column.property] === cellValue && (nextRow.teachingForm === row.teachingForm)) {
              rowspan++
              nextRow = dataProvider[rowspan + rowIndex]
            }
            if (rowspan > 1) {
              return { rowspan, colspan: 1 }
            }
          }
        } else if (columnIndex == 3) {
          if (prevRow && prevRow[column.property] === cellValue && (prevRow.unitPosition === row.unitPosition)) {
            return { rowspan: 0, colspan: 0 }
          } else {
            let rowspan = 1
            while (nextRow && nextRow[column.property] === cellValue && (nextRow.unitPosition === row.unitPosition)) {
              rowspan++
              nextRow = dataProvider[rowspan + rowIndex]
            }
            if (rowspan > 1) {
              return { rowspan, colspan: 1 }
            }
          }
        } else if (columnIndex == 4) {
          if (prevRow && prevRow[column.property] === cellValue && (prevRow.roomType === row.roomType)) {
            return { rowspan: 0, colspan: 0 }
          } else {
            let rowspan = 1
            while (nextRow && nextRow[column.property] === cellValue && (nextRow.roomType === row.roomType)) {
              rowspan++
              nextRow = dataProvider[rowspan + rowIndex]
            }
            if (rowspan > 1) {
              return { rowspan, colspan: 1 }
            }
          }
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.fileName {
  .preview_text {
    color: #3A85FF;
    margin-left: 18px;
    text-decoration: none;
  }
}

.courseName {
  margin-right: 6px;
}

.teachingForm {
  display: inline-block;
  padding: 0px 10px;
  text-align: center;
  color: #ffffff;
  background: #3A85FF;
  border-radius: 15px;
}

.blue_style {
  color: #3A85FF;
  cursor: pointer;
}

.courseTable {
  /deep/ .cell {
    padding-left: 17px !important;
  }
}
</style>
